import { Box } from '@mui/material';
import { Spinner } from '../Spinner/Spinner';

const styles = { width: '100%', height: '100%' };

export interface FullViewSpinnerProps {
  size?: string;
}

export function FullViewSpinner({ size }: FullViewSpinnerProps) {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" sx={styles}>
      <Spinner size={size} />
    </Box>
  );
}
